export enum CamposTipologiaEnum {
  Descricao = 0,
  QuantidadeUnidades = 1,
  QuantidadePermutas = 2,
  AreaLote = 3,
  TipologiaCasas = 4,
  AreaCasa = 5,
  PerimetroMuroPorLote = 6,
  AreaServico = 7,
  PrecoTabela = 8
}
